/* ======================================================================
   PDP — corrector del estado agotado / avisame
   ----------------------------------------------------------------------
   POR QUE EXISTE:
   La ficha lleva un script propio (inyectado en la seccion principal) que
   conmuta tres piezas segun la talla elegida: el boton real de compra, un
   boton falso de "agotado" (#fake-sold-out-btn) y el enlace de Klaviyo
   "avisame cuando este disponible". Ese script escucha variant:change SOBRE
   EL FORMULARIO y crea sus elementos una sola vez: si el tema reemplaza ese
   trozo de DOM al cambiar de variante, el oyente muere y el aviso se queda
   congelado (visto por Andres el 26-jul-2026: talla disponible con el
   "avisame" visible debajo del boton activo).

   QUE HACE:
   Escucha variant:change a NIVEL DE DOCUMENTO (verificado: el evento
   burbujea), asi que sobrevive a cualquier reemplazo de DOM, y tras un
   retardo mayor que el del script original re-impone el estado correcto:
     talla disponible  → boton real visible · fake oculto · avisame oculto
     talla agotada     → boton real oculto  · fake visible · avisame visible

   Solo actua dentro de la ficha (.product-info) para no tocar los
   formularios de quick-buy del carrito o de recomendados.

   Se carga desde snippets/header-search.liquid.
   Para desactivarlo: quitar su linea de carga de ese snippet.
   ====================================================================== */

(function () {
  /* Mayor que el setTimeout(50) del script original, para ganar siempre */
  var DELAY_MS = 180;

  function enforce(scope, available) {
    scope.querySelectorAll('.klaviyo-bis-trigger').forEach(function (el) {
      el.style.display = available ? 'none' : 'block';
    });

    var fake = scope.querySelector('#fake-sold-out-btn');
    if (fake) fake.style.display = available ? 'none' : 'block';

    var form = scope.querySelector('form[id^="product-form"]');
    if (form) {
      var real = form.querySelector('button[type="submit"]:not(#fake-sold-out-btn)');
      if (real) real.style.display = available ? '' : 'none';
    }
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || typeof variant.available === 'undefined') return;

    var scope = e.target && e.target.closest ? e.target.closest('.product-info') : null;
    if (!scope) return; /* evento de otro contexto (quick-buy, upsell) */

    setTimeout(function () {
      enforce(scope, !!variant.available);
    }, DELAY_MS);
  }, true);
})();
